import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { css } from '@emotion/react';
import { useRecoilValue } from 'recoil';

import UserLayer from '@components/Common/UserLayer';

// import { useAccountFeature } from '@hooks/api/useAuthAPIs';
// import { useClientDetail } from '@hooks/api/useClientAPIs';

import { palette } from '@styles/theme';

import { NAVIGATION_WIDTH } from '@constants/layout';
import { Menu } from '@constants/menus';
import { auth } from '@constants/state';

/** 메인 컴포넌트 */
const Navigation = () => {
  const navigate = useNavigate();

  /** 사용자 Layer Modal State */
  const [userLayerOpen, setUserLayerOpen] = useState<boolean>(false);

  /** 전역상태값 호출 (사용자 정보) */
  const userInfo = useRecoilValue(auth);

  /** 고객정보 호출 */
  // const { data } = useClientDetail();

  /** 허용권한 목록 API 호출 (GNB, GROUP, CORP, CORP_DETAIL, REPORT, NOTICE) */
  // const { features, isLoading } = useAccountFeature('INDEX');
  // const { isLoading: groupLoading } = useAccountFeature('GROUP_SUMMARY');
  // const { isLoading: corpLoading } = useAccountFeature('CORP');
  // const { isLoading: corpDetailLoading } = useAccountFeature('CORP_DETAIL');
  // const { isLoading: reportLoading } = useAccountFeature('REPORT');
  // const { isLoading: noticeLoading } = useAccountFeature('NOTICE');

  console.log('USER INFO : ', userInfo.role);

  return (
    <>
      <nav css={container(NAVIGATION_WIDTH)}>
        <div css={logo} onClick={() => navigate('/')}>
          <img src={'/assets/images/gms_logo_2.png'} alt="logo" />
        </div>
        {/* 프로필 */}
        <div css={profiles} onClick={() => setUserLayerOpen(true)}>
          <div
            css={{
              width: '40px',
              height: '40px',
              borderRadius: '5px',
              backgroundColor: palette.colorNavy300,
              color: palette.white,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px',
            }}
          >
            {userInfo?.name?.substring(0, 1)}
          </div>
          <div className="textWrap">
            <div className="name">{userInfo?.name}</div>
            <div className="company">{userInfo?.company}</div>
          </div>
        </div>
        {userLayerOpen && (
          <UserLayer
            open={userLayerOpen}
            handleOpen={() => setUserLayerOpen(false)}
          />
        )}

        <div css={divider} />

        {/* 메뉴 */}
        <ul css={menuWrap}>
          {/* 마스터 계정 SNB 메뉴 */}
          {['ROLE_MARK', 'ROLE_GOWID'].includes(userInfo.role || '') && (
            <>
              <Menu name="groupSetting" />
              <Menu name="accountSetting" />
            </>
          )}

          {/* 관리자 계정 SNB 메뉴 */}
          {userInfo.role === 'ROLE_COMPANY' && (
            <>
              <Menu name="home" />
              <Menu name="management" />
              <Menu name="account" />
              <Menu name="report" />
            </>
          )}

          {/* 파트너 계정 SNB 메뉴 */}
          {userInfo.role === 'ROLE_PARTNER' && (
            <>
              <Menu name="partnerManagement" />
            </>
          )}
        </ul>

        <div css={bottomLogo}>
          <img src="/assets/images/gms_logo_gray.png" alt="IPMS_LOGO" />
        </div>
      </nav>
    </>
  );
};

export default Navigation;

const container = (width: string) => css`
  height: 100vh;
  width: ${width};
  background-color: ${palette.gray1};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-shadow: rgb(0 0 0 / 10%) 2px 0px 5px;
  padding: 20px;
`;

const profiles = css`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  gap: 10px;
  position: relative;
  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 10px;
  }

  .textWrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .name {
      font-size: 15px;
    }
    .company {
      font-size: 13px;
      color: ${palette.gray5};
    }
  }

  &:hover {
    background-color: ${palette.gray2};
  }
`;

const divider = css`
  height: 1px;
  width: 100%;
  background-color: ${palette.gray3};
  margin: 20px 0;
`;

const menuWrap = css`
  height: calc(100vh - 325px);
  li + li {
    margin-top: 10px;
  }
`;

const logo = css`
  display: flex;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 30px;
  img {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    height: 64px;
    width: 100%;
    object-fit: contain;
  }

  &:hover {
    background-color: ${palette.gray2};
  }
`;

const bottomLogo = css`
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 30px;
    object-fit: contain;
  }
`;
